import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const fetchChallengesRequest = createAction('fetchChallengesRequest');
export const fetchChallengesSuccess = createAction<Challenge[]>('fetchChallengesSuccess');
export const fetchChallengesFailure = createAction('fetchChallengesFailure');

export const fetchChallenges = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchChallengesRequest());
    try {
        const { data } = await api.get<Challenge[]>('admin/challenges');
        dispatch(fetchChallengesSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengesFailure, e);
    }
};
